"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditBookingWindow = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../app");
const booking_show_1 = require("../app/components/booking/booking_show");
const client_booking_table_1 = require("../app/components/booking/client_booking_table");
const booking_1 = require("../model/booking");
const auth_1 = require("../utils/auth");
const helpers_1 = require("../utils/helpers");
const alert_box_1 = require("../widgets/alert_box");
const duration_picker_1 = require("../widgets/duration_picker");
const form_for_1 = require("../widgets/form_for");
const modal_1 = require("../widgets/modal");
const calendar_1 = require("./calendar");
let booking;
let isActive = false;
let errorReason = "";
let hasError = false;
let costMessage = "Ce changement n'induit pas de coût pour le client";
function renderHourOfBooking(form) {
    let startsAt = app_1.App.moment(booking.from);
    let timeInDay = startsAt.hour() * 60 + startsAt.minutes();
    //FIXME: Hardcoded because I don't have the dev time and courage to
    //       get the information about the venue
    let min = 8 * 60, max = 21 * 60;
    return [(0, mithril_1.default)("h3", { style: "text-align: center;" }, "Débute à"),
        (0, mithril_1.default)(duration_picker_1.DurationPicker, {
            value: timeInDay,
            minDuration: min,
            maxDuration: max,
            step: app_1.App.BOOKING_STEP,
            onchange: (v) => {
                let newDate = app_1.App.moment(form.obj.from).clone();
                newDate.startOf('day');
                newDate.hour(Math.floor(v / 60));
                newDate.minutes(v % 60);
                form.obj.from = newDate.format();
                getSimulationCost();
            }
        })
    ];
}
function renderDurationOfBooking(form) {
    return [(0, mithril_1.default)("h3", { style: "text-align: center;" }, "Durée"),
        (0, mithril_1.default)(duration_picker_1.DurationPicker, {
            value: form.obj.duration,
            minDuration: app_1.App.BOOKING_MIN_DURATION,
            maxDuration: 600,
            step: app_1.App.BOOKING_STEP,
            onchange: (v) => {
                form.obj.duration = v;
                getSimulationCost();
            }
        })
    ];
}
function renderServices(form) {
    form.obj.additional_services = form.obj.additional_services || [];
    let additional_services = form.obj.additional_services;
    let room = form.obj.room;
    let authorizedServices = (0, helpers_1.fastIntersection)(additional_services, room.available_hardware);
    let toRemove = [];
    for (let idx = 0; idx < additional_services.length; idx++) {
        if (authorizedServices.indexOf(additional_services[idx]) == -1) {
            toRemove.push(idx);
        }
    }
    toRemove.reverse().forEach(idx => { authorizedServices.splice(idx, 1); });
    let array = room.available_hardware.map(hw => {
        // Naive find into array structure
        // in our case perf is not big issue
        // as there's only few services avail. for each rooms.
        return (0, form_for_1.checkbox)(hw, "additional_hardware", form.obj, {
            checked: additional_services.indexOf(hw) != -1,
            oninput: (_e) => {
                let idx = additional_services.indexOf(hw);
                if (idx != -1) {
                    additional_services.splice(idx, 1);
                }
                else {
                    additional_services.push(hw);
                }
            }
        });
    });
    let out = [];
    if (array.length == 0) {
        return (0, mithril_1.default)("div", "Pas de services présents dans cette salle");
    }
    else {
        (0, helpers_1.eachSlice)(array, 3, (slice) => {
            out.push((0, form_for_1.columns)(...slice));
        });
        return out;
    }
}
function renderCosts(form) {
    if (auth_1.Auth.isClient())
        return [];
    return [
        (0, mithril_1.default)("h3", "Calcul des coûts"),
        form.checkbox("A titre gracieux", "gracefully", { oninput: (e) => {
                let data = form.obj;
                data["gracefully"] = e.target.checked;
                getSimulationCost();
            } }),
        renderSimulateMove(form)
    ];
}
const renderForm = (form) => {
    if (booking === undefined)
        return undefined;
    return (0, mithril_1.default)(".content", hasError ? (0, alert_box_1.alertBox)({
        content: errorReason,
        level: "warning",
        onclose: undefined
    }) : undefined, form.errorBlock(), (0, mithril_1.default)("h3", "Heures"), (0, form_for_1.columns)(renderHourOfBooking(form), renderDurationOfBooking(form)), (0, mithril_1.default)("h3", "Services sélectionnés"), renderServices(form), (0, mithril_1.default)("h3", "Infos additionnelles"), auth_1.Auth.clientOnly(form.textarea("Notes personnelles", "client_comment")), auth_1.Auth.clientOnly(form.textarea("Commentaire pour Sésame", "shared_comment")), auth_1.Auth.adminOnly(form.textarea("Commentaire Sésame", "company_comment")), renderCosts(form));
};
function renderFooter(form) {
    return (0, mithril_1.default)("div", { class: "is-pulled-right" }, form.submit("Mettre à jour", {
        disabled: hasError,
        ajax: () => {
            const payload = {
                new_date: booking.from,
                new_room_id: booking.room.id,
                new_duration: booking.duration,
                gracefully: booking.gracefully,
                additional_services: booking.additional_services
            };
            if (auth_1.Auth.isClient())
                payload["client_comment"] = booking.client_comment;
            if (auth_1.Auth.isClient())
                payload["shared_comment"] = booking.shared_comment;
            if (auth_1.Auth.isAdmin())
                payload["company_comment"] = booking.company_comment;
            return app_1.App.patch(`/bookings/${booking.id}`, payload);
        },
        onsubmit: () => {
            isActive = false;
            calendar_1.Calendar.refresh();
            if (auth_1.Auth.isClient())
                client_booking_table_1.ClientBookingTable.fetch();
            if (booking_show_1.BookingShow.booking.id)
                booking_show_1.BookingShow.fetch(booking_show_1.BookingShow.booking.id);
        }
    }), (0, mithril_1.default)("button", { class: "button", onclick: (e) => {
            e.preventDefault();
            isActive = false;
        } }, "Annuler"));
}
function getSimulationCost() {
    hasError = false;
    app_1.App.patch(`/bookings/${booking.id}/simulate_move`, {
        new_date: booking.from,
        new_room_id: booking.room.id,
        new_duration: booking.duration,
        gracefully: booking.gracefully
    }).then((x) => {
        let data = x;
        hasError = !data.move;
        switch (data.reason) {
            case "confirmed":
                errorReason = "La confirmation est déjà confirmée. Vous ne pouvez pas la modifier.";
                break;
            case "services":
                errorReason = "La salle n'a pas les services demandés";
                break;
            default:
                errorReason = data.extra || "";
        }
        if (data.has_cost) {
            costMessage = `Induit des couts: ${(0, helpers_1.minutesToString)(data.costs.total_consumed)} consommé et ${(0, helpers_1.minutesToString)(data.costs.total_free_minutes)} en temps "gratuit"`;
        }
        else {
            costMessage = "Ce changement n'induit pas de coût pour le client";
        }
    });
}
function renderSimulateMove(_form) {
    return (0, mithril_1.default)("div", (0, mithril_1.default)("pre", costMessage));
}
exports.EditBookingWindow = {
    oncreate() {
    },
    edit(bookingId) {
        app_1.App.get(`/bookings/${bookingId}`).then((b) => {
            isActive = true;
            booking = b;
            getSimulationCost();
        });
    },
    view() {
        return (0, form_for_1.formFor)(booking, booking_1.DetailedBookingProvider, (form) => {
            return (0, modal_1.modalCard)({
                title: `Editer la réservation #${booking === null || booking === void 0 ? void 0 : booking.id}`,
                foot: renderFooter(form),
                isActive: isActive,
                onClose: () => {
                    isActive = false;
                },
                content: renderForm(form),
            });
        });
    }
};
